/**
 * useLatestRequest — ใช้เฉพาะ response ของคำขอล่าสุด (BUG-S2268-002)
 *
 * หน้ารายการที่ดึงข้อมูลเองใน useEffect มักยิงหลายรอบตอนเปิดหน้า (ค่าเริ่มต้น → ตัวกรองจาก URL →
 * ขนาดหน้าจาก useUserPageSize) และ response กลับมาไม่เรียงลำดับ → ตัวที่มาช้าสุดทับตาราง
 * (เห็นจริงหน้าซ่อมบำรุง: ตัวกรองโชว์ครบแต่ตารางเป็นข้อมูลไม่กรอง 184 แถว)
 *
 *   const beginRequest = useLatestRequest();
 *   const load = async () => {
 *     const isStale = beginRequest();
 *     const res = await api();
 *     if (isStale()) return;   // มีคำขอใหม่กว่าแล้ว — ทิ้ง
 *     setRows(res.items);
 *   };
 */
import { useCallback, useRef } from 'react';

export function useLatestRequest(): () => () => boolean {
  const seqRef = useRef(0);
  return useCallback(() => {
    const seq = ++seqRef.current;
    return () => seq !== seqRef.current;
  }, []);
}

export default useLatestRequest;
